var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['ac-checkbox', 'd-flex', 'align-items-center', { checked: _vm.value, disabled: _vm.disabled }],on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('div',[_vm._v(_vm._s(_vm.$t(_vm.placeholderTranslation)))]),(_vm.value)?_c('div',{staticClass:"close"},[_c('IconsIconClose')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }